module.exports = __webpack_public_path__ + "static/media/addingWebsiteAnimated.ac955140.gif";